import storeLink from "fragments/vendors/storeLink"
import gql from "graphql-tag"

const GET_STORE_LINKS = gql`
  ${storeLink}

  query getStoreLinks($query: GetQueryStoreLinks) {
    getStoreLinks(query: $query) {
      ...StoreLink
    }
  }
`
export default GET_STORE_LINKS
